import { render, staticRenderFns } from "./DataComplianceTemp.vue?vue&type=template&id=5513baf2&scoped=true"
import script from "./DataComplianceTemp.vue?vue&type=script&lang=js"
export * from "./DataComplianceTemp.vue?vue&type=script&lang=js"
import style0 from "./DataComplianceTemp.vue?vue&type=style&index=0&id=5513baf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513baf2",
  null
  
)

export default component.exports